<template>
  <div :class="header?'header':''">
    <van-nav-bar :title="title" @click-left="toBack"  :right-text="rightText" @click-right="onClickRight">
      <template #left>
        <img src="@/assets/back.png" alt="返回" width="21" height="21">
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    isBack: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '这是标题'
    },
    leftIcon: {
      type: Boolean,
      default: true
    },
    rightIcon: {
      type: Boolean,
      default: true
    },
    header: {
      type: Boolean,
      default: true
    },
    rightText: {
      type: String,
      default: ''
    }
  },
  methods: {
    toBack() {
      //this.$router.go(-1)
      const vm = this;
      if (vm.isBack){
        this.$router.go(-1)
      } else {
        vm.$emit("back");
      }
    },
    onClickRight() {
      this.$emit('onClickRight')
    }
  }
}
</script>

<style scoped>
  .van-nav-bar{
    background-color: #F3F3F3;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue